import apiurl from './apiurl';
import axios from 'axios';

const obj= {
    updateDevice: async (idToken,params) =>        
    axios({
        'method':'put',
        'url':apiurl +'updateDevice',
        'headers': {
            'content-type':'application/json',
            'Authorization':"Bearer "+idToken
        },
        data: params,
        'crossdomain': true,
    })
    
};

export default obj;